/* global axios */
// TOOLS-03 — as instâncias de template da conta e a credencial que o cliente digita nelas.
//
// Usa o axios global (carrega os headers de sessão do DeviseTokenAuth) — um `fetch` cru não manda
// header de auth e toma 401.
//
// O VALOR só viaja para o servidor, nunca de volta: `secrets` na resposta é um mapa de
// `{definido, definido_em}` por campo. Não existe método de leitura de segredo neste cliente
// porque não existe rota — e é isso que impede a tela de virar caminho de exfiltração.
const BASE = accountId => `/api/v1/accounts/${accountId}/tool_instances`;

const body = r => r.data;

export default {
  index(accountId) {
    return axios.get(BASE(accountId)).then(r => r.data?.payload || []);
  },

  show(accountId, id) {
    return axios.get(`${BASE(accountId)}/${id}`).then(body);
  },

  // Manda SÓ os campos que mudaram: campo ausente é campo não tocado, e string vazia apaga.
  // Mandar tudo a cada salvar faria o "definido em" de todos os campos pular para hoje, e a tela
  // passaria a dizer que houve rotação onde não houve.
  updateSecrets(accountId, id, secrets) {
    return axios
      .patch(`${BASE(accountId)}/${id}/secrets`, { secrets })
      .then(body);
  },
};
